module.exports = __webpack_public_path__ + "6fbb9efd20c35085c47d8a0a3b40ca1d.png";